<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>Ultrapassando fronteiras</h2>
          <p>
            Para aumentar a capacidade produtiva, a empresa arrenda e depois
            compra do <strong>Grupo Bordon</strong> a unidade de Anápolis (GO),
            com capacidade de abater 1.000 animais por dia. A iniciativa
            representa um passo importante com a comercialização de carnes
            desossadas.
          </p>
          <img
            src="../assets/img/1993/1993-1.jpg"
            alt=""
            @click="showMultiple(0)"
          />
        </div>
        <div class="formato__warpper__item--image">
          <img
            src="../assets/img/1993/1993-2.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/1992/07/17/g/19920717-36066-nac-0038-eco-10-not-pwekkqk.jpg'
              )
            "
          />
          <img
            src="../assets/img/1993/1993-3.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/1993/08/13/g/19930813-36458-nac-0021-cid-3-not-hagwshk.jpg'
              )
            "
          />
          <img src="../assets/img/1993/1993-5.png" alt="" class="nohover" />
          <p></p>
        </div>
        <div class="formato__warpper__item--black">
          <h2>A popularização do fast-food</h2>
          <p>
            Se dentro de casa a evolução da alimentação se deu pelos
            eletrodomésticos, nas refeições fora do lar as transformações
            aconteceram principalmente no modelo de negócio dos restaurantes.
            Nos anos 1990, com economia e cotidiano cada vez mais acelerados,
            muitas pessoas trocaram as refeições completas em restaurantes por
            um novo tipo de hábito: a comida rápida, mais conhecida como
            <strong>fast-food</strong>.
          </p>
          <p>
            Para a indústria de alimentos, uma das principais novidades foi o
            avanço da inseminação artificial em animais, favorecendo projetos de
            cruzamento industrial. Com ajuda da genética, foi possível criar
            novas raças de gado, mais adaptadas ao clima local e com maior
            eficiência.
          </p>

          <div class="images">
            <img
              src="../assets/img/1993/1993-4.png"
              alt=""
              @click="
                openLink(
                  'https://acervo.estadao.com.br/publicados/1993/06/30/g/19930630-36414-nac-0059-agr-3-not-pxshahk.jpg'
                )
              "
            />
            <span
              ><i class="icon-eye"></i
              ><strong>clique nas imagens para ampliar</strong></span
            >
          </div>
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from "./Ano.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import { defineComponent } from "vue";

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ["ano"],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    openLink(link) {
      window.open(link, "_blank");
    },
    showMultiple(index) {
      this.imgsRef = [
        {
          src: require("@/assets/img/1993/1993-1-full.jpg"),
          title:
            "1993 - A empresa arrenda e depois compra do Grupo Bordon a unidade de Anápolis (GO), com capacidade de abater 1.000 animais por dia.",
        },
      ];
      this.indexRef = index; // index of imgList
      this.onShow();
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 100px;
    display: grid;
    grid-template-columns: 525px 240px 288px;
    justify-content: space-between;
    gap: 10px;
    @include media("<=desktop") {
      grid-template-columns: 1fr;
    }
  }
  &__warpper {
    position: relative;

    &__item {
      position: relative;
      @include media("<=desktop") {
        padding: 0 20px;
      }
      &--image {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        @include media("<=desktop") {
          padding: 0 20px;
          align-items: center;
        }
        img {
          margin: 10px 0;
          &:nth-child(3) {
            display: none;
          }
        }
        span {
          position: absolute;
          left: -70px;
          bottom: 50px;
          width: 65px;
          color: color(cBlue4);
          strong {
            color: color(cBlue4);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cGreen);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
      }
      h2 {
        color: color(primary);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
      }
      p {
        color: color(cText);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
      }
      img {
        cursor: pointer;
      }

      &--black {
        padding-block: 50px;
        @include media("<=desktop") {
          padding: 30px 20px;
          background: color(cBlue5);
        }
        img {
          margin: 20px 0;
        }

        .images {
          position: relative;
          @include media("<=desktop") {
            display: flex;
            justify-content: center;
          }

          span {
            position: absolute;
            left: -75px;
            bottom: 0;
            width: 65px;
            color: color(cBLue6);
            @include media("<=desktop") {
              display: none;
            }
            strong {
              color: color(primary);
              font-family: font(primary);
              font-size: 0.75rem;
              font-style: normal;
              font-weight: 400;
              line-height: 116.5%;
              background: color(cBLue6);
            }
            i {
              display: block;
              font-size: 1.3rem;
            }
          }
        }
        p {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
          max-width: 371px;
          margin: 0 auto;
          margin-bottom: 10px;
          strong {
            font-style: italic;
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
        h2 {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          max-width: 371px;
          margin: 0 auto;
          margin-bottom: 10px;
        }
        blockquote {
          color: color(cBlue);
          font-family: font(primary);
          font-family: JBS Text;
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          position: relative;
          max-width: 370px;
          margin: 10px auto;
          &::before {
            content: "\e901";
            font-family: "icomoon" !important;
            display: block;
            font-size: 1rem;
            line-height: initial;
            margin-bottom: 17px;
          }
        }
      }
    }
    &::after {
      content: "";
      background: color(cBlue5);
      width: 45%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      @include media("<=desktop") {
        display: none;
      }
    }
  }
}
</style>
